// extracted by mini-css-extract-plugin
module.exports = {"templatesPage":"TemplatesPage_templatesPage__2D9YA","templateBlock":"TemplatesPage_templateBlock__YSE-4"};